<template>
  <div class="user">
    <el-card class="box-card" shadow="never">
      <el-form ref="form" :inline="true" :model="form">
        <el-form-item label="组织" v-if="auth.includes(8)">
          <el-select class="select-input" v-model="form.groupId" placeholder="请选择组织" clearable>
            <el-option v-for="(item, index) in groupList" :key="index" :label="item.groupName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item><el-input clearable v-model="form.searchKey" style="width:230px" placeholder="请输入关键字 名称 电话 账号"></el-input></el-form-item>
        <el-form-item><el-button type="primary" @click="searchUserPage">搜索</el-button></el-form-item>
        <el-form-item v-if="auth.includes(9)"><el-button type="primary" @click="showAddUserDiloag">添加</el-button></el-form-item>
      </el-form>

      <el-table :data="tableData" border height="64vh" style="width: 100%;margin-top:10px;" :row-class-name="tableRowClassName">
        <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
        <el-table-column prop="username" label="账号"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="120"></el-table-column>
        <el-table-column prop="updateTime" label="时间" width="170">
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.status == 0 ? '删除' : '正常' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <el-button v-show="auth.includes(10)" @click="delUser(scope.row)" type="text" size="small">{{ scope.row.status == 0 ? '恢复' : '删除' }}</el-button>
            <!-- <el-button @click="showEditUserDiloag(scope.row)" type="text" size="small">修改</el-button> -->
            <el-button type="text" v-show="auth.includes(12)" size="small" @click="showAddRoleDiloag(scope.row)">角色分配</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="form.page"
        :page-sizes="pageList"
        :page-size="form.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;margin-top:20px;"
      ></el-pagination>
    </el-card>
    <!-- 添加用户 -->
    <Dialog ref="dlgAddUser" :title="dlgTitle">
      <el-form ref="ruleForm" :model="userData" label-width="70px" :rules="rules">
        <el-form-item label="账号" prop="username"><el-input v-model="userData.username"></el-input></el-form-item>
        <el-form-item label="姓名" prop="name"><el-input v-model="userData.name"></el-input></el-form-item>
        <el-form-item label="手机号" prop="mobile"><el-input v-model="userData.mobile"></el-input></el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-select v-model="userData.sex" placeholder="请选择性别" style="width:100%">
            <el-option v-for="(item, index) in sexOptions" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="text-align:right" class="btn-tools"><el-button class="btn" type="primary" @click="onSave('ruleForm')">保存</el-button></el-form-item>
      </el-form>
    </Dialog>
    <!-- 分配角色 -->
    <Dialog ref="dlgAddRole" title="角色分配">
      <el-form ref="roleForm" :model="roleForm" label-width="80px">
        <el-form-item><el-checkbox v-for="(item, index) in roleData" :key="index" :label="item.roleName" v-model="item.checked"></el-checkbox></el-form-item>
        <el-form-item style="text-align:right" class="btn-tools"><el-button class="btn" type="primary" @click="onSaveRole('roleForm')">保存</el-button></el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
import USERAPI from '@/api/user';
import GROUPAPI from '@/api/group';
import ROLEAPI from '@/api/role';
import Dialog from '@/components/dialog';
import { getInfo } from '@/utils/auth';
export default {
  components: {
    Dialog
  },
  data() {
    return {
      auth: [],
      form: {
        size: 10,
        page: 1,
        groupId: '',
        searchKey: '',
        groupId: 1
      },
      userData: {},
      total: 0,
      dlgTitle: '',
      pageList: [10, 20, 30, 50],
      tableData: [],
      groupList: [],
      roleForm: {},
      roleData: [],
      rules: {
        username: [
          {
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }
        ],
        sex: [
          {
            required: true,
            message: '请选择性别',
            trigger: 'change'
          }
        ]
      },
      currentRow: {}, //选中的当前行
      sexOptions: [
        {
          label: '男',
          value: 1
        },
        {
          label: '女',
          value: 2
        }
      ]
    };
  },
  methods: {
    //设置每行的颜色
    tableRowClassName({ row, rowIndex }) {
      return '';
      if (rowIndex === 0) {
        return 'warning-row';
      } else if (rowIndex === 1) {
        return 'success-row';
      }
    },
    //初始数据
    init() {
      //获取所有访问属性
      this.auth = this.COMM.getActiveAuth();
      let info = getInfo();
      let tp = typeof info;
      if (tp == 'string') {
        this.form.groupId = JSON.parse(info).groupId;
      }
      if (this.auth.includes(8)) {
        GROUPAPI.searchGroup().then(res => {
          this.groupList = res.data.data;
          // if (!this.form.groupId) {
          //   this.form.groupId = this.groupList[0].id;
          // }
          let params = this.form;
          USERAPI.searchUserPage(params).then(res => {
            this.tableData = res.data.data.content;
            this.total = res.data.data.totalElements;
          });
        });
      } else {
        let params = this.form;
        USERAPI.searchUserPage(params).then(res => {
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements;
        });
      }
    },
    //获取用户列表数据
    searchUserPage() {
      this.tableData = [];
      let params = this.form;
      USERAPI.searchUserPage(params).then(res => {
        this.tableData = res.data.data.content;
        this.total = res.data.data.totalElements;
      });
    },
    //获取组织列表
    searchGroup() {
      GROUPAPI.searchGroup().then(res => {
        this.groupList = res.data.data;
      });
    },
    //获取角色列表
    searchRolePage(row) {
      let params = {
        userId: row.id,
        groupId: this.form.groupId
      };
      ROLEAPI.searchUserBindRoles(params).then(res => {
        this.roleData = res.data.data;
        this.$refs.dlgAddRole.open();
      });
    },
    //显示对话框
    showAddUserDiloag() {
      if (this.form.groupId) {
        this.dlgTitle = '新增用户';
        this.$refs.dlgAddUser.open();
      } else {
        this.$message.warning('请选择组织');
      }
    },
    //显示对话框
    showEditUserDiloag(row) {
      if (this.form.groupId) {
        this.dlgTitle = '编辑用户';
        this.userData = row;
        this.$refs.dlgAddUser.open();
      }
    },
    //显示角色列表
    showAddRoleDiloag(row) {
      this.currentRow = row;
      this.searchRolePage(row);
    },
    //添加用户
    addUser() {
      let params = {};
      params.groupId = this.form.groupId;
      params.user = this.userData;
      USERAPI.addUser(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchUserPage();
        }
      });
    },
    //修改用户
    updateUser() {
      let params = {};
      params.groupId = this.form.groupId;
      params = this.userData;
      USERAPI.updateUser(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.searchUserPage();
        }
      });
    },
    //删除用户
    delUser(row) {
      let self = this;
      this.$confirm('确定要执行此操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          USERAPI.deleteUser({
            dataId: row.id
          }).then(res => {
            this.$message.success('操作成功');
            self.searchUserPage();
          });
        })
        .catch(() => {});
    },
    //保存
    onSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.userData.id) {
            this.updateUser();
          } else {
            this.addUser();
          }
          this.onCancel();
        } else {
          return false;
        }
      });
    },
    //用户绑定角色
    bindUserRoles() {
      let params = {};
      params.userId = this.currentRow.id;
      params.roleIds = [];
      this.roleData.forEach(item => {
        if (item.checked) {
          params.roleIds.push(item.roleId);
        }
      });
      ROLEAPI.bindUserRoles(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('操作成功');
          this.$refs.dlgAddRole.close();
        }
      });
    },
    //保存绑定角色
    onSaveRole(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.bindUserRoles();
        } else {
          return false;
        }
      });
    },
    //取消保存
    onCancel() {
      this.$refs.dlgAddUser.close();
    },
    //设置页数
    handleSizeChange(val) {
      this.form.size = val;
      this.searchUserPage();
    },
    //设置当前页
    handleCurrentChange(val) {
      this.form.page = val;
      this.searchUserPage();
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss">
@import './static/css/boss.scss';
.user {
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
}

.btn-tools {
  .btn {
    width: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/boss/user/index.vue